import { getService } from '../utils';

export const getSkillsService = getService('skills');
